<script>
  import BgColor from "./Components/color.svelte"
  import { onMount } from "svelte"
  export let textColor
  export let backgroundColor
  export let colorCount
  export let position = "bottom"
  let activeTab = "bgClr"
  let colorPalette
  export let codeView
  export let column = 5

  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showPalette = false
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  /**
   * @type {HTMLElement} binded the overall dropdown parent element
   */
  let palette

  let translatingX

  /**
   * @description function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (palette.contains(e.target) == false) showPalette = false
  }

  onMount(() => {
    if (showPalette) {
      checkColorPalettePosition()
    }
  })

  /**
   * @description Function for managing the color palette position in the window based on the
   * available screen space.
   */
  const checkColorPalettePosition = () => {
    if (colorPalette) {
      // Get the bounding rectangle of the color palette element
      let paletteBoundingRects = colorPalette.getClientRects()[0]

      // Check if the color palette overflows the window on the right side
      let paletteOverflowedRight = paletteBoundingRects.left + 450 > window.innerWidth

      // Check if the color palette overflows the window on the left side
      let paletteOverflowedLeft = paletteBoundingRects.left < 0

      // Adjust the translation value for the color palette if it overflows
      if (paletteOverflowedRight) {
        translatingX = -(paletteBoundingRects.width - (window.innerWidth - paletteBoundingRects.left))
      }
      if (paletteOverflowedLeft) {
        translatingX = 0
      }
    }
  }
</script>

<svelte:window on:click={onCloseDropDown} />

<div id="palette" class="relative w-9" bind:this={palette}>
  <button
    disabled={codeView}
    type="button"
    on:click={() => {
      showPalette = !showPalette
      setTimeout(() => {
        checkColorPalettePosition()
      }, 10)
    }}
    class="flex h-9 w-9 items-center justify-center rounded-r-md bg-gray-50 text-sm font-medium text-gray-900 hover:bg-slate-200 focus:outline-none disabled:cursor-not-allowed dark:bg-[#2d2d2d] dark:text-gray-200 dark:hover:bg-bodyblack"
  >
    <i class="fa-solid fa-chevron-down" />
  </button>
  {#if showPalette}
    <div bind:this={colorPalette} style="--translatingX: {translatingX}px;width: {column * 52.8 + 40}px" class="transformed absolute left-0 z-10 {position} max-h-fit overflow-auto rounded-md border border-[#a0a1a580] bg-white p-3 text-base shadow-2xl ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm">
      <div class="flex w-full gap-3">
        <button
          on:click={() => {
            activeTab = "bgClr"
          }}
          type="button"
          class="rounded-md {activeTab == 'bgClr' ? 'rounded-md bg-[#f7f7f7] dark:bg-bodyblack dark:text-slate-200' : 'bg-transparent'} w-full px-2 py-1 text-sm font-bold text-[#5A5A5C] disabled:cursor-not-allowed"
        >
          Background Color
        </button>
        <button
          on:click={() => {
            activeTab = "txtClr"
          }}
          type="button"
          class="rounded-md {activeTab == 'txtClr' ? 'rounded-md bg-[#f7f7f7] dark:bg-bodyblack dark:text-slate-200' : 'bg-transparent'} w-full px-2 py-1 text-sm font-bold text-[#5A5A5C] disabled:cursor-not-allowed"
        >
          Text Color
        </button>
      </div>
      <div class="pt-3">
        {#if activeTab == "bgClr"}
          <BgColor bind:backgroundColor bind:textColor on:bgClrChosen {activeTab} {colorCount} {column} />
        {:else}
          <BgColor bind:textColor bind:backgroundColor on:textClrChosen {activeTab} {colorCount} {column} />
        {/if}
      </div>
    </div>
  {/if}
</div>

<style>
  .top {
    bottom: 40px;
    left: 0px;
  }
  .bottom {
    margin-top: 4px;
  }
  .transformed {
    transform: translateX(var(--translatingX));
  }
</style>
